export const trueToFalse = [
  { value: '5', text: 'True' },
  { value: '4', text: 'More true than false' },
  { value: '3', text: 'Neither true nor false' },
  { value: '2', text: 'More false than true' },
  { value: '1', text: 'False' },
  { value: null, text: 'Not sure/Not Applicable', is_na: true },
];
